<template>
  <div v-if="show">
    <div class="pop_bind">
      <div class="mask" @click="close"></div>
      <div class="bind">
        <div class="tel">
          <span class="icon"></span>
          <input
            type="tel"
            maxlength="11"
            placeholder="输入手机号"
            @blur="setscroll"
            v-model="verifytel"
          />
          <span
            class="right"
            :class="{ telable: verifytel.length == 11 }"
            @click="getverify"
            >{{ timetext }}</span
          >
        </div>
        <div class="lines"></div>
        <div class="title">输入获取的验证码</div>
        <input
          class="num"
          type="tel"
          ref="verifyinput"
          maxlength="5"
          @input="setverifynum"
          v-model="verifynum"
        />
        <div class="boxs" @click="setfocus">
          <span
            class="box"
            :class="{ border: verifyboxindex === index }"
            :key="index"
            v-for="(i, index) in 5"
          >
            {{ verifynum.split("")[index] }}
          </span>
        </div>
        <div
          class="btn"
          v-if="!move"
          @click="bind"
          :class="{ able: verifytel.length == 11 && verifynum.length == 5 }"
        >
          登录
        </div>
        <div class="btn" v-else>
          登录中
        </div>
      </div>
    </div>
    <div class="pop_code" v-if="isshowpopcode">
      <div class="pop_code-mask" @click="isshowpopcode = false"></div>
      <div class="pop_code-box">
        <div class="head">请在下方输入图片验证码</div>
        <div class="input">
          <input
            type="text"
            v-model="verifycode"
            @blur="setscroll"
            placeholder="请输入"
            maxlength="4"
          />
          <img class="codeimg" :src="srccode" alt="" />
        </div>
        <div class="btn" v-if="!move" @click="setcode">确定</div>
        <div class="btn" v-else>正在获取短信</div>
      </div>
    </div>
  </div>
</template>

<script>
import Lib from "../assets/Lib.js";

export default {
  data() {
    return {
      show: false,
      isshowpopcode: false,
      verifytel: "",
      verifycode: "",
      verifynum: "",
      verifyboxindex: "",
      timeover: "",
      time: 59,
      timetext: "发送验证码",
      backurl: "",
      srccode: "",
      move: false,
      callback: null,
      isclose: null,
      codenum: 0,
      isVerify: "",
    };
  },
  methods: {
    //
    setscroll() {
      window.scrollTo(0, 0);
    },
    // 设置获取焦点
    setfocus() {
      this.$refs.verifyinput.focus();
      this.setverifyboxindex();
    },
    // 设置失去焦点
    setblur() {
      this.$refs.verifyinput.blur();
    },
    //
    setverifynum() {
      this.setverifyboxindex();
      if (this.verifynum.length === 5) {
        this.setblur();
      }
    },
    //
    setverifyboxindex() {
      this.verifyboxindex = this.verifynum.length;
    },
    // 获取图形验证次数
    getcodenum(cb) {
      Lib.M.ajax({
        type: "get",
        url: Lib.C.api.smstcodenum,
        data: {
          cellphone: this.verifytel,
        },
        success: (res) => {
          this.codenum = res.result;
          cb && cb();
        },
        complete: () => {},
        error: () => {},
      });
    },
    // 获取验证码
    getverify() {
      // 验证次数（超过2次）
      this.getcodenum(() => {
        if (this.codenum > 2) {
          if (this.verifytel.length == 11) {
            if (this.timetext === "发送验证码") {
              this.isshowpopcode = true;
              this.getcode();
            }
          }
        } else {
          this.verifycode = "1234";
          this.isVerify = "1234";
          this.setcode();
        }
      });
    },
    //获取短信
    setcode() {
      if (!this.verifycode) return;
      if (this.move) return;
      this.move = true;
      Lib.M.ajax({
        type: "get",
        url: Lib.C.api.smsdcode,
        data: {
          cellphone: this.verifytel,
          valiImgCode: this.verifycode,
          isVerify: this.isVerify,
        },
        success: (res) => {
          this.isshowpopcode = false;
          if (res.result.sendOk) {
            Lib.M.MsgBox.hint("短信验证码已发送请注意查收");
            this.settimeover();
          } else {
            Lib.M.MsgBox.hint("验证码发送次数已超过限制");
          }
        },
        complete: () => {
          this.verifycode = "";
          this.move = false;
        },
        error: () => {
          this.getcode();
        },
      });
    },
    //获取验证图片
    getcode() {
      this.srccode = `${Lib.C.api.smstcode}?device_id=${
        this.verifytel
      }&t=${Date.now()}`;
    },
    // 倒计时
    settimeover() {
      this.timeover = setTimeout(() => {
        if (this.time === 0) {
          this.timetext = "发送验证码";
          this.time = 59;
          this.timeover && clearInterval(this.timeover);
        } else {
          this.timetext = `${this.time}s`;
          this.time--;
          this.settimeover();
        }
      }, 1000);
    },
    // 关闭提示
    toastover() {
      this.isshowtoast = false;
    },
    // 微信走绑定 支付宝走登录
    bind() {
      if (this.verifytel.length == 11 && this.verifynum.length == 5) {
        if (this.move) return;
        this.move = true;
        if (Lib.device.isWeixin) {
          this.dobind();
        }
        if (Lib.device.isAlipay) {
          this.dologin();
        }
      }
    },
    // 绑定
    dobind() {
      Lib.M.ajax({
        type: "get",
        url: Lib.C.api.smsbind,
        data: {
          openid: Lib.M.wsCache.get("openid"),
          cellphone: this.verifytel,
          valicode: this.verifynum,
        },
        success: (res) => {
          const info = Lib.M.wsCache.get("UserInfo");
          info.msisdn = res.result.cellphone;
          info.userId = res.result.user_id;
          Lib.M.wsCache.set("UserInfo", info, { exp: Lib.C.sexp });

          this.callback && this.callback();
          this.bindclose();
        },
        complete: () => {
          this.move = false;
        },
        error: () => {
          this.verifynum = "";
        },
      });
    },
    // 登录
    dologin() {
      Lib.M.ajax({
        noalert: true,
        type: "post",
        url: `${Lib.C.api.smslogin}?cellnumber=${this.verifytel}&valicode=${
          this.verifynum
        }`,
        data: {},
        success: async (res) => {
          Lib.M.wsCache.set("UserInfo", res.result, { exp: Lib.C.sexp });
          this.callback && this.callback();
          this.bindclose();
        },
        complete: () => {
          this.move = false;
        },
        error: (res) => {
          Lib.MsgBox.hint(res.data.errorMsg);
          this.verifytel = "";
          this.verifynum = "";
        },
      });
    },
    close() {
      if (this.isclose) {
        this.bindclose();
      }
    },
    // 关闭
    bindclose() {
      this.verifytel = "";
      this.verifycode = "";
      this.verifynum = "";
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes showhide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
div {
  margin: 0 auto;
}
.pop_bind {
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #303237;
    opacity: 0.45;
    z-index: 3000;
  }
  .bind {
    height: 7.2rem;
    width: 6.7rem;
    border-radius: 0.16rem;
    background-color: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -3.6rem 0 0 -3.35rem;
    z-index: 4000;
    padding-top: 0.6rem;
    text-align: center;
    > div {
      margin: 0 auto;
    }
    .tel {
      width: 5.4rem;
      position: relative;
      font-size: 0.3rem;
      color: #aab3c4;
      padding: 0.2rem 0;
      padding-left: 0.54rem;
      text-align: left;
      .icon {
        display: block;
        height: 0.4rem;
        width: 0.4rem;
        background: url(../assets/images/icon_tel.png);
        background-size: 100% 100%;
        position: absolute;
        left: -0.04rem;
        top: 50%;
        margin-top: -0.2rem;
      }
      .right {
        position: absolute;
        right: 0.1rem;
        color: #c9cdf6;
      }
      .telable {
        color: #4854df;
      }
      input {
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.3rem;
        color: #303237;
        border: none;
      }
    }
    .lines {
      height: 1px;
      width: 5.4rem;
      background-color: #303237;
      box-shadow: 0 0.04rem 0.08rem rgba(0, 0, 0, 0.4);
    }
    .title {
      height: 0.4rem;
      font-size: 0.28rem;
      color: #303237;
      line-height: 0.4rem;
      width: 5.4rem;
      margin-bottom: 0.28rem;
      margin-top: 0.7rem;
      text-align: left;
    }
    .boxs {
      overflow: hidden;
      width: 5.4rem;
      margin: 0 auto;
      .box {
        display: block;
        float: left;
        height: 0.8rem;
        width: 0.8rem;
        margin-right: 0.34rem;
        background-color: #f5f5f5;
        position: relative;
        line-height: 0.8rem;
        text-align: center;
        font-size: 0.3rem;
        color: #303237;
        .line {
          display: block;
          height: 0.4rem;
          width: 0.04rem;
          background-color: #dedede;
          position: absolute;
          left: 50%;
          top: 50%;
          margin-top: -0.2rem;
          margin-left: -0.02rem;
          opacity: 1;
          animation: showhide 1s infinite;
        }
      }
      .box:last-child {
        margin-right: 0;
      }
      .border {
        border: 1px solid #303237;
      }
    }
    .num {
      opacity: 0.9;
      position: absolute;
      left: -9999px;
      top: 0;
    }
    .agree {
      color: #9ca1af;
      font-size: 0.24rem;
      padding-left: 0.4rem;
      position: relative;
      margin-top: 0.3rem;
      .check {
        display: block;
        height: 0.26rem;
        width: 0.26rem;
        background: url(../assets/images/icon_check_small.png);
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -0.13rem;
      }
    }
    .btn {
      width: 5rem;
      height: 0.96rem;
      line-height: 0.96rem;
      text-align: center;
      border-radius: 0.48rem;
      color: #9ca1af;
      background-color: #d7d9df;
      box-shadow: 0px 12px 12px 0px rgba(0, 0, 0, 0.06);
      font-weight: 400;
      font-size: 0.3rem;
      margin-top: 0.8rem;
      margin-bottom: 0.8rem;
    }
    .able {
      color: #303237;
      background-color: #ffd80e;
      box-shadow: 0 0.12rem 0.12rem 0 rgba(255, 216, 14, 0.18);
    }
  }
}
.pop_code {
  .pop_code-mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #000;
    opacity: 0.5;
    z-index: 6000;
  }
  .pop_code-box {
    height: 4.64rem;
    width: 6.42rem;
    background-color: #fff;
    border-radius: 0.16rem;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -2.32rem;
    margin-left: -3.21rem;
    z-index: 7000;
    .head {
      text-align: center;
      font-size: 0.3rem;
      color: #303237;
      margin-bottom: 0.6rem;
      margin-top: 0.6rem;
    }
    .input {
      width: 5.2rem;
      height: 0.9rem;
      border-radius: 0.12rem;
      border: 1px solid #d7d9df;
      background-color: #fff;
      position: relative;
      padding-top: 0.15rem;
      margin-bottom: 0.7rem;
      input {
        width: 3.2rem;
        height: 0.6rem;
        font-size: 0.3rem;
        margin-left: 0.3rem;
        border: none;
      }
      .codeimg {
        height: 0.78rem;
        width: 1.8rem;
        position: absolute;
        top: 50%;
        right: 0.1rem;
        margin-top: -0.39rem;
        border-radius: 0.12rem;
      }
    }
    .btn {
      width: 5rem;
      height: 0.96rem;
      background-color: #ffd80e;
      box-shadow: 0 0.06rem 0.06rem 0 rgba(255, 216, 14, 0.18);
      border-radius: 0.48rem;
      color: #303237;
      font-size: 0.32rem;
      text-align: center;
      line-height: 0.96rem;
    }
  }
}
</style>
